import { STARTLOADING, STOPLOADING, ERROR, HASREZULT } from "../types"


const initState = {
  loading: false
}

const statusLoader = (state = initState, action) => {
  switch(action.type){
    case STARTLOADING:
      return {...state, loading: true}
    case STOPLOADING:
    case HASREZULT:
    case ERROR: 
      return {...state, loading: false}
    default:
      return state
  }
}

export default statusLoader